import { jsx } from "react/jsx-runtime";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { DSSingleComboBox } from "@elliemae/ds-form-single-combobox";
import { Grid } from "@elliemae/ds-grid";
import { useMemo } from "react";
import { useFormState, useWatch } from "react-hook-form";
import _ from "lodash";
import { useSingleComboboxFieldUpdateLogic } from "../utils/fieldUpdateLogic";
const DefaultAndBankruptcy = ({
  renderedField,
  schemaForm,
  id,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  options
}) => {
  const singleComboboxFieldUpdateLogic = useSingleComboboxFieldUpdateLogic();
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const allComboboxOptions = useMemo(() => {
    const newOpts = options.filter((option) => option.visible).map((option) => ({
      dsId: `${option.id}`,
      type: "option",
      label: `${option.text}`,
      value: `${option.value}`,
      default: option.default
    }));
    return newOpts || [];
  }, [options]);
  const bankruptcyInMonths = useWatch({
    control: schemaForm.control,
    name: "borrowerFinancialHistory.bankruptcyInMonths"
  });
  const noticeOfDefault = useWatch({
    control: schemaForm.control,
    name: "borrowerFinancialHistory.noticeOfDefaultForeClosure"
  });
  const normalizedValue = ["Notice of Default (NOD)", "Bankruptcy"].includes(name) && renderedField.value === null ? "null" : renderedField?.value?.toString();
  const isEmpty = (val) => val === null || val === "null";
  const forceDisableMap = {
    "Bankruptcy Type": isEmpty(bankruptcyInMonths),
    "NOD Type": isEmpty(noticeOfDefault)
  };
  const isDisabled = forceDisableMap[name] ?? false;
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      inputID: name,
      required,
      feedbackMessage,
      hasError: !!errors[id] || !!errorMessage,
      validationMessage: errors[id]?.message?.toString() || errorMessage,
      children: /* @__PURE__ */ jsx(
        DSSingleComboBox,
        {
          ...renderedField,
          allOptions: allComboboxOptions,
          onChange: singleComboboxFieldUpdateLogic(
            renderedField,
            schemaForm,
            id
          ),
          selectedValue: !normalizedValue && allComboboxOptions.some((option) => option.default) ? allComboboxOptions.find((option) => option.default) : allComboboxOptions.find(
            (option) => option.value === normalizedValue
          ) || null,
          id: pathValue,
          disabled: isDisabled
        }
      )
    }
  ) });
};
export {
  DefaultAndBankruptcy
};
